var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M9.8 21V12.8H7.5V9.8H9.7V7.1C9.7 5.9 10.1 5 10.8 4.2C11.6 3.4 12.8 3 14.2 3C14.6 3 15 3 15.3 3C15.7 3 16 3.1 16.1 3.1H16.4V6H14.5C14 6 13.6 6.1 13.4 6.4C13.2 6.6 13.1 7 13.1 7.5V9.7H16.5L16.3 12.7H13.2V21H9.8Z","fill":"#111930"}})
}
var staticRenderFns = []

export { render, staticRenderFns }